import { SVGIcon } from '@superops/super-icons';
import { Button, TextStyle } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { TicketDetailsModal } from '@nile/mangifera/src/Modal/TicketDetailsModal';
import {
  AccessControl,
  COMMON_CONSTANTS,
  useActivityTracker
} from '@nile/components';

const DataComponent = ({ title, icon }) => {
  return (
    <div className="flex g5 actr">
      <div className="flex ignoreOverride">
        <SVGIcon name={icon} color="#ffffffcc" size="sm" />
      </div>
      <div>
        <TextStyle variation="aiSubdued">{title}</TextStyle>
      </div>
    </div>
  );
};

const SilimarTicketCard = (props) => {
  const {
    ticketId,
    displayId,
    subject,
    siteName,
    resolved,
    clientName,
    summary,
    mixpanelEventOnOpen
  } = props;
  const [activeTicket, setActiveTicket] = useState(null);

  const openTicketDetailsModal = () => {
    if (mixpanelEventOnOpen) {
      useActivityTracker(mixpanelEventOnOpen);
    }
    setActiveTicket({
      ticketId: ticketId,
      displayId: displayId
    });
  };

  const closeTicketDetailsModal = () => {
    setActiveTicket(null);
  };

  return (
    <div id="ai-similar-ticket-card" className="p10 br10 ai-dark-bg">
      <div className="text-white">
        <TextStyle weight="Medium">{subject}</TextStyle>
      </div>

      {summary && (
        <div className="mt-10">
          <TextStyle variation="aiSubdued">{summary}</TextStyle>
        </div>
      )}

      <div className="flex g20 mt10 fsize12">
        <div className="flex actr">
          <div className="flex ignoreOverride">
            <SVGIcon name="TicketOutline" color="#ffffffcc" size="sm" />
          </div>
          <div className="flex actr">
            <Button aiPlain onClick={openTicketDetailsModal} plain>
              <div className="flex fsize12 ml-5">
                <TextStyle>#{displayId}</TextStyle>
              </div>
            </Button>
          </div>
        </div>
        {siteName && (
          <AccessControl
            productToCheck={COMMON_CONSTANTS.MSP}
            render={<DataComponent title={siteName} icon="Location" />}
          />
        )}

        {clientName && (
          <AccessControl
            productToCheck={COMMON_CONSTANTS.MSP}
            render={<DataComponent title={clientName} icon="ClientLogo" />}
          />
        )}
      </div>
      {activeTicket && (
        <TicketDetailsModal
          ticket={activeTicket}
          onClose={closeTicketDetailsModal}
        />
      )}
    </div>
  );
};

export default SilimarTicketCard;
